module.exports = __webpack_public_path__ + "img/CompScope_Mag_2_Focus_2.49a9dc04.png";